import React from 'react';
import {Outlet} from 'react-router-dom';
import {Layout} from 'antd';

const {Content} = Layout;

const ContentLayout = () => {
  return (
    <Content className={'p-4 bg-primary-50'}>
      <Outlet />
    </Content>
  );
};

export default ContentLayout;
